import React, { Component } from "react";
import ProductHeader from "../ProductDetails/ProductHeader";
import { ReactComponent as Error } from "../CheckoutProcess/assets/error.svg";
import { connect } from "react-redux";
import ActionButton from "../ActionButton";
import { withRouter } from "react-router";

class RegisteringFailed extends Component {
  render() {
    const language = this.props.language;
    return (
      <div style={{ backgroundColor: "white" }}>
        <ProductHeader
          onBack={() => {
            this.props.history.replace("/wait", {
              waiting_list: this.props.waiting_list,
            });
            window.location.reload();
          }}
        />
        <div className="free-space-190-white"></div>
        <Error width="100" height="100" />
        <h1 className="mt-3" dir={language == "english" ? "ltr" : "rtl"}>
          {language == "english" ? "Oops.." : ""}
        </h1>
        <p
          className="mt-3 mx-auto mb-0"
          style={{ fontSize: "1rem", width: "90%" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language === "english" ? "Please Try Again" : "حاول مره اخرى"}
        </p>

        <ActionButton
          allowWithMenu
          action={language == "english" ? "Back" : "الرجوع"}
          onClick={() => {
            this.props.history.replace("/");
            window.location.reload();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(withRouter(RegisteringFailed));
